import DocumentEditor from './components/SalesEmailEditor';
import DocumentPreview from './components/SalesEmailPreview';
import {
  getPdfContent, getTxtContent, getCsvContent, getClipboardItem,
} from './SalesEmail.getContent';
import Icon from './SalesEmail.icon';

const getWordCounts = (document) => {
  return [{
    title: 'Subject',
    value: document.content ? document.content.subject : '',
  }, {
    title: 'Body',
    value: document.content ? document.content.emailBody : '',
  }];
};

const file = {
  DocumentEditor,
  DocumentPreview,
  getPdfContent,
  getTxtContent,
  getCsvContent,
  getClipboardItem,
  Icon,
  getWordCounts,
  stringifyContent: (templateContent) => `Subject:  ${templateContent.subject}
  Email Body: ${templateContent.emailBody}`,
};

export default file;
